// Deal Pipeline spec §4.4 — pickers backed by /api/users/assignable.
//
// The API has no dedicated B1 / A1 picker endpoint, so we reuse
// the assignable-users surface via the shared useAssignableUsers hook (one
// unfiltered fetch, role filtering client-side). useUserDisplayMap builds an
// id → display-name lookup from a users list.

import { useMemo } from "react";
import { type AssignableUserDto } from "@/api/users";
import { useAssignableUsers } from "@/hooks/useAssignableUsers";

export const useB1Picker = () => useAssignableUsers("B1");
export const useA1Picker = () => useAssignableUsers("A1");
export const useC1Picker = () => useAssignableUsers("C1");

/** Build a display-name lookup from a users list — handy for KanbanBoard
 *  + tables which need to render assignees but only have ids. */
export function useUserDisplayMap(users: AssignableUserDto[] | undefined) {
  return useMemo(() => {
    const map = new Map<string, string>();
    for (const u of users ?? []) map.set(u.id, u.displayName);
    return map;
  }, [users]);
}
